<fieldset [disabled]="loading">
  <ng-content></ng-content>
</fieldset>

<agc-preloader *ngIf="loading"></agc-preloader>
